
import React from "react";

interface NoReportsMessageProps {
  title: string;
  description: string;
}

const NoReportsMessage: React.FC<NoReportsMessageProps> = ({ title, description }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-50/50 dark:bg-gray-800/50 z-10">
      <div className="text-center p-6 rounded-lg bg-white dark:bg-gray-700 shadow-md max-w-md">
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="text-muted-foreground">{description}</p>
      </div>
    </div>
  );
};

export default NoReportsMessage;
